import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import OrderAndOverviewData from "./OrderAndOverviewData";

@usingJsonToModelConvertor
export class DiscountCodeApplyDetails extends Model {

    @fromJsonObject({key: 'applied'})
    public applied!: boolean;

    @fromJsonObject({key: 'message'})
    public message!: string;

}


@usingJsonToModelConvertor
export default class DiscountCodeResponse extends Model {

    @fromJsonObject({key: 'order_and_overview_data', modelClass: OrderAndOverviewData, isArray: false})
    public orderAndOverviewData!: OrderAndOverviewData;

    @fromJsonObject({key: 'code_details', modelClass: DiscountCodeApplyDetails, isArray: false})
    public codeDetails!: DiscountCodeApplyDetails;

}
